module.exports = __webpack_public_path__ + "img/3d_desc_img.ec9810b6.png";